import { useParentPageContext } from '@/finsight/application/ParentPageContext';
import { ArticlesType } from '@/finsight/ui/components/creditFlow/articles/constants';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import { UserPlanType } from '@/users/domain/UserPlan';
import UserSubscriptionsContextProvider
  from '@/finsight/application/Subscriptions/UserSubscriptionsContext/UserSubscriptionsContext';
import ArticlesMarketThemesContextProvider from '@/finsight/application/CreditFlowResearch/ArticlesMarketThemesContext';
import ArticlesTile from './ArticlesTile';
import TileAccessFallback from './TileAccessFallback';
import capitalize from '@/Framework/dataHelpers/string/capitalize';

import styles from './articlesTiles.scss';

interface IProps {
  isSubscribeButtonVisible?: boolean,
}

const ArticlesTiles = ({ isSubscribeButtonVisible = true }: IProps) => {
  const { articlesTilesData: { commentariesList, dealFlowList } } = useParentPageContext();

  return (
    <div className={ styles.wrapper }>
      { Object.values(ArticlesType).map((articlesType) => (
        <div className={ styles.tile } key={ articlesType } data-test={ `articlesTile${ capitalize(articlesType) }` }>
          <CheckUserPlanAccess
            requiredUserPlan={ UserPlanType.PREMIUM }
            fallback={ <TileAccessFallback articlesType={ articlesType } /> }
          >
            <ArticlesTile
              initialData={ articlesType === ArticlesType.commentary ? commentariesList : dealFlowList }
              themeType={ articlesType }
              isSubscribeButtonVisible={ isSubscribeButtonVisible }
            />
          </CheckUserPlanAccess>
        </div>
      )) }
    </div>
  );
};

export default ({ isSubscribeButtonVisible = true }: { isSubscribeButtonVisible?: boolean }) => (
  <CheckUserPlanAccess
    requiredUserPlan={ UserPlanType.PREMIUM }
    fallback={ <ArticlesTiles /> }
  >
    <ArticlesMarketThemesContextProvider>
      <UserSubscriptionsContextProvider>
        <ArticlesTiles isSubscribeButtonVisible={ isSubscribeButtonVisible } />
      </UserSubscriptionsContextProvider>
    </ArticlesMarketThemesContextProvider>
  </CheckUserPlanAccess>
);
